/* getUserMenuNavItems.ts */

/* Ionic */
import {
  help,
  settings,
  information,
  book,
} from "ionicons/icons";

/* Constants */
import { Paths } from "src/shared/constants/common/Paths";
import { UserRoles } from "src/shared/constants/auth/User";

/* Interfaces */
import { NavItemProps } from "src/shared/interfaces/common/NavItem";

export const getUserMenuNavItems = (
  roles: string[] = []
): NavItemProps[] => {
  const isAdmin = roles.includes(UserRoles.ADMIN);

  const items: NavItemProps[] = [];

  if (isAdmin) {
    items.push({
      name: "Admin dashboard",
      icon: settings,
      path: Paths.ADMIN_DASHBOARD,
    });
  }

  items.push(
    {
      name: "Help & Support",
      icon: help,
      path: Paths.HELP_SUPPORT,
      disabled: true,
    },
    {
      name: "Glossary",
      icon: book,
      path: Paths.GLOSSARY,
      disabled: false,
    },
    {
      name: "Imprint",
      icon: information,
      path: Paths.IMPRINT,
      disabled: false,
    }
  );

  return items;
};
